import {SkuFoodCategoryCountType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import {Card} from "antd";
import React from "react";
import {FONT_SIZE_DATA_LABELS} from "../../../../common/constants";

// Тип пропсов для компонента: ожидает массив данных по категориям
type MiddlePriceChartPropsType = {
    data: SkuFoodCategoryCountType[]
}

export const MiddlePriceChart = ({data}: MiddlePriceChartPropsType) => {

    // Массив для названий категорий
    const categories: string[] = []
    // Массив для витринных цен
    const dataVit: number[] = []
    // Массив для цен со скидкой
    const dataSale: number[] = []

    // Заполнение массивов для графика
    data.forEach((el) => (dataVit.push(el.price_vit), dataSale.push(el.price_sale), categories.push(el.name_category)))

    // Формирование данных для серии графика
    const series = [
        {
            name: 'Цена витринная',
            data: dataVit
        },
        {
            name: 'Цена со скидкой',
            data: dataSale
        }
    ]

    // Базовая ширина графика и расчет ширины при большом количестве столбцов
    const baseWidth = 1400; // базовая ширина контейнера (до 15 столбцов)
    const extraWidthPerBar = 95; // дополнительная ширина на каждый столбик сверх 15
    let chartWidth = baseWidth;

    if (data.length > 15) {
        chartWidth += (data.length - 15) * extraWidthPerBar;
    }

    // Опции для ApexCharts: настройки графика, осей, сетки, подписей, цветов, тултипа и легенды
    const options = {
        chart: {
            type: 'bar' as 'bar',
            toolbar: {
                show: false,
                tools: {
                    download: false
                }
            },
        },
        yaxis: {
            show: false,
        },
        grid: {
            borderColor: '#202020',
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            padding: {
                left: 40,
                right: 40,
                bottom: 20
            }
        },
        dataLabels: {
            enabled: true,
            textAnchor: 'middle' as 'middle',
            offsetY: -5,
            style: {
                fontSize: FONT_SIZE_DATA_LABELS,
                fontWeight: 600,
            },
            background: {
                enabled: false,
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#202020']
        },
        plotOptions: {
            bar: {
                columnWidth: '70%',
                endingShape: 'rounded',
                hideZeroBarsWhenGrouped: false,
                dataLabels: {
                    position: 'center',
                    orientation: /*count >= 20 ? 'vertical' as 'vertical' : */'horizontal' as 'horizontal',
                    hideOverflowingLabels: true,
                    total: {
                        enabled: true,
                        style: {
                            color: '#373d3f',
                            fontSize: '15px',
                            fontFamily: undefined,
                            fontWeight: 600
                        }
                    }
                },
            }
        },
        title: {
            text: `Средние цены`,
            align: data.length > 15 ? 'left' as const : 'center' as const  ,
            margin: 20,
            style: {
                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        xaxis: {
            type: 'category' as 'category',
            categories: categories,
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: categories && categories.length > 8,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',
                },
            },
        },
        legend: {
            position: 'top' as 'top',
            offsetY: -10,
            fontSize: '14px',
            labels: {
                colors: '#FFFFFF'
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: false
            },
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            x: {
                show: true,
            },
            marker: {
                show: true,
            }
        },
    }

    // Отрисовка карточки с графиком средних цен
    return (
        <div>
            <Card style={{
                background: '#293133',
                borderRadius: 20,
                marginTop: 20,
                marginBottom: 20,
                width: '100%',
                overflowX: 'auto'
            }}>
                {/* График средних цен ApexCharts */}
                <ReactApexChart
                    options={options}
                    series={series}
                    type={'bar'}
                    height={500}
                    style={{color: '#FFFFFF'}}
                    width={chartWidth}
                />
            </Card>
        </div>
    );
};
